<template>
  <div class="main">
    <keep-alive include="merchants-platforms-list">
      <component :is="currentTabComponent" @changeTab="changeTab" ref="subComponent" :contData="contData"></component>
    </keep-alive>
  </div>
</template>

<script>
import listComponent from "./list/index";
import orgComponent from "./organization/index";
export default {
  name: "merchants-platforms",
  data(){
    return {
      currentTabComponent: "listComponent",
      contData: null,
    }
  },
  methods: {
    changeTab(data){
      this.currentTabComponent = data.name;
      this.contData = data.contData ? data.contData : {};
      if(data.refresh){
        this.$nextTick(()=>{
          this.$refs.subComponent.$_callback();
        });
      }
    }
  },
  components: {
    listComponent,
    orgComponent
  }
}
</script>

<style lang="scss" scoped>
.main{
  display: flex;
  -webkit-box-orient: vertical;
  flex-direction: column;
  margin: 0!important;
  height: 100%!important;
  border: none!important;
}
</style>